module.exports = __webpack_public_path__ + "static/img/8.8b5961c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/8.png
// module id = EClC
// module chunks = 0